// src/utils/api.js
import axios from "axios";
import generateAuthHeader  from "../utils/authHeader";
import { baseUrl } from "../config";

const api = axios.create({
  baseURL: baseUrl, // change to your backend URL
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  
  // Apply other headers first (API keys, etc)
  const otherHeaders = generateAuthHeader();
  config.headers = { ...config.headers, ...otherHeaders };

  // Set Authorization exactly how the backend wants it
  if (token) {
    // REMOVED 'Bearer' prefix based on your requirement
    config.headers["Authorization"] = token; 
  }

  return config;
}, (error) => Promise.reject(error));

export default api;
